import React, { Component } from "react";
import "./Settings.scss";
import {
    Tabs,
    Select,
    Switch,
    message,
} from "antd";
import {
    FaArrowLeft,
    FaArrowRight,
    FaBell,
} from "react-icons/fa";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import {
    ChangeLanguageReq,
    EnableNotifications,
} from "../../network/profile.network";
import { connect } from "react-redux";
import { setCurrentUser } from "../../redux/user/user.action";

const { TabPane } = Tabs;
const { Option } = Select;

class Settings extends Component {
    formAgencyRef = React.createRef();
    state = {
        showAddLang: false,
        notificationsEnalbe: true,
        langVal: true,
        inputLoading: false,
        tableLoading: false,
        isAgencyEdit: false,
        AgencyId: false,
        funderState: "list",
        financingAgencies: [],
    };
    componentDidMount() {
        const { currentUser } = this.props;
        //this.fetchAllFinancingAgencies();
        this.setState({ notificationsEnalbe: currentUser?.IsNotificationEnabled });
        this.setState({ langVal: currentUser?.IsArabic });
    }

    closeDltModal = () => {
        this.setState({ showDltModal: false });
    };

    itemRender = (current, type, originalElement) => {
        if (type === "prev") {
            return (
                <a className="prev-page-btn pagin-page-btn">
                    <FaArrowRight /> الصفحة السابقة{" "}
                </a>
            );
        }
        if (type === "next") {
            return (
                <a className="next-page-btn pagin-page-btn">
                    الصفحة التاليه <FaArrowLeft />{" "}
                </a>
            );
        }
        return originalElement;
    };

    notificationsChange = (value) => {
        this.setState({ inputLoading: true });
        EnableNotifications(
            value,
            (res) => {
                const updateUser = {
                    ...this.props.currentUser,
                    IsNotificationEnabled: value,
                };
                this.props.dispatch(setCurrentUser(updateUser));
                message.success(res.data.metas.message);
                this.setState({ inputLoading: false, notificationsEnalbe: value });
            },
            (err) => {
                this.setState({ inputLoading: false });
            }
        );
    };

    handelChangeLanguage = (value) => {
        const { langVal } = this.state;
        this.setState({ inputLoading: true });
        ChangeLanguageReq(
            langVal,
            (res) => {
                const updateUser = { ...this.props.currentUser, IsArabic: langVal };
                this.props.dispatch(setCurrentUser(updateUser));
                this.setState({ inputLoading: false, showAddLang: false });
                message.success(res.data.metas.message);
            },
            (err) => {
                this.setState({ inputLoading: false });

            }
        );
    };

    render() {
        const {
            showDltModal,
            notificationsEnalbe,
            inputLoading,
        } = this.state;
        // const { currentLang, metaData } = this.props;
        return (
            <div className="setting-page-wrapper">
                {showDltModal && (
                    <DeleteModal
                        delete={this.handeldeleteFinancingAgency}
                        name="جهه التمويل"
                        closeDltModal={this.closeDltModal}
                    />
                )}
                <div className="container">
                    <h1 className="setting-page-title">الإعدادات</h1>
                    <div className="setting-content-wrapper">
                        <div className="client-steps-wrapper">
                            <Tabs tabPosition="left" className="client-tabs-wrapper">
                                {/* <TabPane
                                    tab={
                                        <span>
                                            <FaGlobeAsia />
                                            اللغه
                                        </span>
                                    }
                                    key="2"
                                >
                                    <div className="single-tab-holder">
                                        <h4 className="single-tab-title">اللغه</h4>
                                        <h4 className="single-tab-span">اختر اللغه التي تناسبك</h4>
                                        {showAddLang ? (
                                            <Form
                                                className="form-add-content form-lang-holder"
                                                layout="vertical"
                                                name="nest-messages"
                                                onFinish={this.handelChangeLanguage}
                                            >
                                                <div className="form-content">
                                                    <Form.Item
                                                        label="اللغه"
                                                        name="langInput"
                                                        className="input-holder"
                                                    >
                                                        <Select
                                                            loading={inputLoading}
                                                            onChange={(langVal) => this.setState({ langVal })}
                                                            defaultValue={langVal}
                                                            value={langVal}
                                                        >
                                                            <Option value={true}>العربيه</Option>
                                                            <Option value={false}>English</Option>
                                                        </Select>
                                                    </Form.Item>
                                                </div>
                                                <div className="form-btns-action">
                                                    <Button
                                                        className="xlg ml-20"
                                                        size="large"
                                                        type="primary"
                                                        ghost
                                                        danger
                                                        onClick={() =>
                                                            this.setState({ showAddLang: false })
                                                        }
                                                    >
                                                        <FaTimes />
                                                        الغاء
                                                    </Button>
                                                    <Button
                                                        htmlType="submit"
                                                        size="large"
                                                        className="blue-btn xlg"
                                                        type="primary"
                                                        loading={inputLoading}
                                                    >
                                                        <FaSave />
                                                        حفظ
                                                    </Button>
                                                </div>
                                            </Form>
                                        ) : (
                                            <div className="info-grid">
                                                <div className="info-grid-cell lang-cell">
                                                    <p className="info-cell-p"> اللغه</p>
                                                    <h6 className="info-cell-val">
                                                        {langVal ? "العربيه" : "English"}
                                                        <FaPen
                                                            onClick={() =>
                                                                this.setState({ showAddLang: true })
                                                            }
                                                        />
                                                    </h6>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </TabPane> */}
                                <TabPane
                                    tab={
                                        <span>
                                            <FaBell />
                                            الاشعارات
                                        </span>
                                    }
                                    key="3"
                                >
                                    <div className="single-tab-holder">
                                        <h4 className="single-tab-title">الاشعارات</h4>
                                        <h4 className="single-tab-span">
                                            يمكنك تحديد اذ يمكنك استلام الاشعارات او لا
                                        </h4>
                                        <div className="notify-holder">
                                            <Switch
                                                size="small"
                                                loading={inputLoading}
                                                onChange={this.notificationsChange}
                                                checked={notificationsEnalbe}
                                            />
                                            <p>استقبال الاشعارات</p>
                                        </div>
                                    </div>
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    currentUser: state.user.currentUser,
    currentLang: state.user.currentLang,
    metaData: state.user.metaData,
});

export default connect(mapStateToProps)(Settings);
